import { render, staticRenderFns } from "./KSjh.vue?vue&type=template&id=cf9ccede&scoped=true"
import script from "./KSjh.vue?vue&type=script&lang=js"
export * from "./KSjh.vue?vue&type=script&lang=js"
import style0 from "./KSjh.vue?vue&type=style&index=0&id=cf9ccede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9ccede",
  null
  
)

export default component.exports